var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2153EB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.418 7.96h-8.917a2.584 2.584 0 0 0-2.581 2.581v8.918A2.585 2.585 0 0 0 10.5 22.04h8.917A2.585 2.585 0 0 0 22 19.46V10.54a2.584 2.584 0 0 0-2.582-2.581zM14.96 19.635A4.64 4.64 0 0 1 10.325 15a4.64 4.64 0 0 1 4.635-4.635A4.64 4.64 0 0 1 19.595 15a4.64 4.64 0 0 1-4.635 4.635zm4.784-8.312a1.098 1.098 0 0 1-1.097-1.096 1.098 1.098 0 0 1 2.194 0c0 .604-.492 1.096-1.097 1.096z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.96 12.324A2.68 2.68 0 0 0 12.283 15a2.68 2.68 0 0 0 2.677 2.677A2.68 2.68 0 0 0 17.636 15a2.68 2.68 0 0 0-2.676-2.676z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.96 0C6.698 0 0 6.698 0 14.96c0 8.261 6.698 14.96 14.96 14.96 8.261 0 14.96-6.699 14.96-14.96C29.92 6.698 23.22 0 14.96 0zm8.998 19.459a4.545 4.545 0 0 1-4.54 4.54h-8.917a4.545 4.545 0 0 1-4.54-4.54V10.54a4.545 4.545 0 0 1 4.54-4.54h8.917a4.545 4.545 0 0 1 4.54 4.54v8.918z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.92ec91cf987a7efc37da13c48e47c5a3.svg";
export { ForwardRef as ReactComponent };